<div sondermindMediaQueryAttribute>
  <ng-content select="[mobile-header]"></ng-content>
  <ng-content select="[header]"></ng-content>
  <ng-content select="[mainMenu]"></ng-content>
  <ng-content select="[linkMenu]"></ng-content>
</div>
<div class="footer-items">
  <ng-content select="[footer]"></ng-content>
</div>